import React, { Component } from "react";
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css";


class SearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [
                { id: 0, label: "item 1" },
                { id: 2, label: "item 2" },
                { id: 3, label: "item 3" },
                { id: 4, label: "item 4" }
            ],
            selectedItems: [],
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleItemDataFormat = this.handleItemDataFormat.bind(this);
    }


    handleChange(selectedItems) {
        this.props.handleChange(selectedItems, this);
        // this.setState({ selectedItems });
    }

    handleItemDataFormat(data) {

        var id = (this.props.selectConfig.id_value !== null && this.props.selectConfig.id_value !== undefined) ? this.props.selectConfig.id_value : 'id';

        var value = (this.props.selectConfig.label_value !== null && this.props.selectConfig.label_value !== undefined) ? this.props.selectConfig.label_value : 'label';

        let final_data = data.map((element, i) => {
            // let innerArray = {};
            element['id'] = element[id];
            element['label'] = `${element[value]}`;
            return element;
        });

        return final_data;

    }


    render() {
        // const { items, selectedItems } = this.state;
        var selectConfig = this.props.selectConfig;
        
        var selectConfigItems = this.handleItemDataFormat(this.props.selectConfig.itemData);
        return (
            <div className={selectConfig['class']}>
                <MultiSelect
                    items={selectConfigItems}
                    selectedItems={selectConfig['selectedItems']}
                    onChange={this.handleChange}
                    showSelectedItems={false}
                    itemHeight={40}
                    height={400}
                    responsiveHeight={'80%'}
                    isAllSelected={true}
                />
            </div>
        );
    }
}

export default SearchSelect;